import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { createApiClient } from 'src/lib/api-client'
import { setDatadogRUMUser } from 'src/lib/monitoring/monitoring'

const patientVideoCallSignIn = async ({
  trialUid,
  patientVideoCallUid,
}: {
  trialUid: string
  patientVideoCallUid: string
}): Promise<void> => {
  const res = await createApiClient({
    path: '/trials/{trialUid}/patient_video_calls/{patientVideoCallUid}/signin',
    httpMethod: 'post',
    params: {
      paths: {
        trialUid,
        patientVideoCallUid,
      },
    },
  }).request()

  if (res.result === 'error') {
    throw new Error(res.error.data.message)
  }

  // 本当はTrialPatientUIDをセットしたいが、ここではないため取れる情報だけセット
  // 将来的に `/trials/{trial_uid}/trial_patients/{trial_patient_uid}/signin_patient` に移行する
  setDatadogRUMUser({
    trialUid: trialUid,
    patientVideoCallUid: patientVideoCallUid,
    role: 'Patient',
  })
}

export const usePatientVideoCallSignIn = (option?: UseMutationOption<void>) => {
  return useMutation(
    ({
      trialUid,
      patientVideoCallUid,
    }: {
      trialUid: string
      patientVideoCallUid: string
    }) => patientVideoCallSignIn({ trialUid, patientVideoCallUid }),
    option,
  )
}
